<!-- eslint-disable @angular-eslint/template/no-call-expression -->
@if (products$ | async; as products) {
  @if (products.length > 0) {
    <div
      lazyLoad
      (lazyLoad)="onFirstView(products)">
      @if (piece) {
        <idt-common-styles-render [styles]="piece.settings?.styles">

      <render-modal-panel
        aria-labelledby="add-to-cart-modal"
        #addToCartModal="render-modal-panel"
        [modalName]="'add-to-cart-modal-' + piece.id"
        [modalType]="isMobile ? 'full' : 'notification'"
        [hasToShowCloseButton]="false"
        [addToBody]="isMobile"
      >
        @if(addToCartModal.open) {
          <render-add-to-cart-modal
            [props]="addToCartModal.props$ | async">
          </render-add-to-cart-modal>
        }
      </render-modal-panel>

      @if (piece && showSliderHeader) {
        <header class="slider-title">

        @if (piece.settings?.general?.showTitle
          && piece.settings?.general?.textGridTitle !== null) {
          <render-wysiwyg
            [piece]="piece"
            [html]="piece.settings?.general?.textGridTitle"
            [textPaddingTop]="piece.settings?.general?.textTitlePadding?.textPaddingTop"
            [textPaddingBottom]="piece.settings?.general?.textTitlePadding?.textPaddingBottom"
            [textPaddingLeft]="piece.settings?.general?.textTitlePadding?.textPaddingLeft"
            [textPaddingRight]="piece.settings?.general?.textTitlePadding?.textPaddingRight">
          </render-wysiwyg>
        }

        @if (arrowPosition === 'header-right') {
          <ng-container [ngTemplateOutlet]="sliderArrows"></ng-container>
        }

      </header>
      }
      <div
        class="carousel-wrapper"
        role="region"
        tabindex="0"
        [attr.aria-label]="piece?.settings?.accessibility?.titleText"
        (keydown)="onKeyDown($event)">
        <div
          #swiper
          cmsSwiper
          aria-live="polite"
          class="swiper-container"
          [ngClass]="{ 'swiper-container-multirow': gridSize.numberOfRows > 1 }"
          [config]="swiperConfig">
          <div class="swiper-wrapper">
            <div
              #accessibilityAnnouncer
              class="sr-only"
              aria-live="polite"
              aria-atomic="true">
            </div>
            <div
              class="sr-only"
              aria-live="polite">
              Carrusel de productos. Use las teclas de flecha izquierda y derecha para navegar entre productos.
              Presione Enter para acceder al selector de tallas. Presione Escape para salir del selector.
            </div>
            @for (product of products; track trackByProduct($index, product); let index = $index) {
              <div
                #swiperSlide
                class="swiper-slide"
                role="group"
                tabindex="0"
                [attr.aria-label]="'Producto ' + (index + 1) + ' de ' + products.length + ': ' + product.name"
                aria-roledescription="slide">
              <div
                class="product-card"
                [attr.data-index]="index">
                <div
                  class="image-product">
                  <render-link
                    class="image-link-product"
                    [lang]="lang"
                    [link]="getProductLink(product, index)"
                    (renderLinkEvent)="onProductLinkClick(product, index)">
                    @if (getProductImageData(product); as imageData) {
                      <img
                        alt="{{ (imageData.src! | getAltText | async) || product.longDescription }}"
                        [class]="imageClass"
                        [lazySrc]="imageData"/>
                    }
                  </render-link>
                  @if (isVisibleCart()) {
                    <render-product-purchase-options
                      [ngClass]="isMobile ? 'product-sizes-mobile' : 'product-sizes'"
                      [product]="product"
                      [country]="country"
                      [lang]="lang"
                      [piece]="piece"
                      [originInfoEvent]="piece?.settings?.general?.origin || 'cross-custom-home'"
                      [providerInfoEvent]="piece?.settings?.general?.provider || provider"
                      [strategyInfoEvent]="piece?.settings?.general?.strategy || strategy"
                      [objectiveInfoEvent]="piece?.settings?.general?.objective || objective">
                    </render-product-purchase-options>
                  }
                </div>
                @if (isVisibleName() || isVisiblePrice() || isVisibleButtonLink()) {
                  <div class="product-data">
                  <div
                    class="product-container">
                    @if (isVisibleName()) {
                      <render-wysiwyg
                        class="product-name"
                        [html]="getTextProductName(product.name)"
                        [piece]="piece">
                      </render-wysiwyg>
                    }
                    @if (isVisibleColors()) {
                      <render-product-colors
                        class="product-colors"
                        [product]="product"
                        [lang]="lang"
                        [piece]="piece">
                      </render-product-colors>
                    }
                  </div>
                  @if (isVisiblePrice()) {
                    <render-product-prices
                      [product]="product"
                      [piece]="piece">
                    </render-product-prices>
                  }
                  @if (isVisibleButtonLink()) {
                    <render-link
                      class="button-link-product"
                      [lang]="lang"
                      [link]="getProductLink(product, index)">
                      <render-wysiwyg
                        [html]="piece.settings?.general?.textButtonLink"
                        [piece]="piece"
                        [textPaddingTop]="piece.settings?.general?.textPaddingTop"
                        [textPaddingBottom]="piece.settings?.general?.textPaddingBottom"
                        [textPaddingLeft]="piece.settings?.general?.textPaddingLeft"
                        [textPaddingRight]="piece.settings?.general?.textPaddingRight">
                      </render-wysiwyg>
                    </render-link>
                  }
                </div>
                }
              </div>
              </div>
            }
            <div class="swiper-pagination"></div>
          </div>
        </div>

        <render-modal-panel
          aria-labelledby="product-size-modal"
          #productSizeModal="render-modal-panel"
          [modalName]="'size-selector-modal-' + piece.id"
          [modalType]="'full'"
          [hasToShowCloseButton]="false"
        >
          @if (productSizeModal.open) {
            <render-product-sizes-modal [props]="productSizeModal.props$ | async">
            </render-product-sizes-modal>
          }
        </render-modal-panel>

        @if (arrowPosition === 'inside-left-right') {
          <ng-container [ngTemplateOutlet]="sliderArrows"></ng-container>
        }
      </div>
        </idt-common-styles-render>
      }
    </div>
  }

  <ng-template #sliderArrows>
    @if (displayComponentArrows && isScrollPager) {
      <div
        class="component-arrows arrow-control">
        <button
          (click)="arrowClick('prev')"
          class="arrow-left"
          [attr.aria-label]="piece?.settings?.accessibility?.previousText"
          tabindex="0"
          [disabled]="isFirstSlide">
          <svg
            class="swiper-arrow"
            viewBox="0 0 11 16"
            fill="none">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.82242 8L10.6154 14.532L9.08879 16L0.769231 8L9.08879 -8.65753e-07L10.6154 1.46796L3.82242 8Z" />
          </svg>
        </button>
        <button
          (click)="arrowClick('next')"
          class="arrow-right"
          [attr.aria-label]="piece?.settings?.accessibility?.nextText"
          tabindex="0"
          [disabled]="isLastSlide">
          <svg
            class="swiper-arrow"
            viewBox="0 0 11 16"
            fill="none">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.79296 8L0 1.46796L1.5266 0L9.84615 8L1.5266 16L0 14.532L6.79296 8Z" />
          </svg>
        </button>
      </div>
    }
  </ng-template>
}
